module.exports = __webpack_public_path__ + "static/media/icon.cf2ba5c7.jpg";